import { useTranslation } from 'react-i18next';
import { UserCompanyContactsList } from './UserCompanyContactsList';
import { CompanySelector } from './CompanySelector';

interface UserCompanyContactsSectionProps {
  companyContacts: any[] | undefined;
  loggedInUser: any;
  showCreateCompany?: boolean;
  onContactClick: (companyId: string, contactId: string) => void;
}

// Renders the company contacts section with pending join requests, contacts list, and company selector
export function UserCompanyContactsSection({
  companyContacts,
  loggedInUser,
  showCreateCompany,
  onContactClick,
}: UserCompanyContactsSectionProps) {
  const { t } = useTranslation();

  const hasCompanyContacts = companyContacts && companyContacts.length > 0;
  const hasActiveJoinRequest = !!loggedInUser?.activeJoinRequest;
  const shouldShowCompanySelector = !hasCompanyContacts && !hasActiveJoinRequest && showCreateCompany === true;

  return (
    <>
      {hasActiveJoinRequest && (
        <div className="border border-border rounded-lg p-4 mb-4 bg-surface">
          <p className="text-sm text-onsurface">
            {t('userProfile.pendingJoinRequest', {
              companyName: loggedInUser.activeJoinRequest!.companyName,
            })}
          </p>
        </div>
      )}
      {hasCompanyContacts && (
        <div className="border border-border rounded-lg overflow-hidden">
          <UserCompanyContactsList
            contacts={companyContacts}
            onContactClick={onContactClick}
          />
        </div>
      )}
      {shouldShowCompanySelector && <CompanySelector />}
    </>
  );
}
